export default "__VITE_ASSET__BFvf93zl__"